module.exports = __webpack_public_path__ + "static/media/10-12.34ac221a.mp3";